module.exports = __webpack_public_path__ + "static/media/file-add-symbol-new.6ad78cd8.svg";